import { Boat } from '@shared/models/boat';
import { InvoicePosition } from '@shared/models/invoice-position';

/** Boat selected in the position dialog (dynamic price) or passed from the calling screen (e.g. boat Bierdeckel). */
export function resolveInvoicePositionBoat(position: InvoicePosition, contextBoat?: Boat): Boat | undefined {
    if (position.boat?.id) {
        return position.boat;
    }
    const dynamicBoat = position.dynamicPrice?.boat;
    if (dynamicBoat?.id) {
        return dynamicBoat as Boat;
    }
    return contextBoat?.id ? contextBoat : undefined;
}

/** Boat a saved position is already linked to - the edit dialog does not carry it into its result. */
export function storedInvoicePositionBoat(position: InvoicePosition): Boat | undefined {
    if (position?.boat?.id) {
        return position.boat;
    }
    return position?.bcm_boats_id ? {id: position.bcm_boats_id} as Boat : undefined;
}

export function applyInvoicePositionBoatForSave(position: InvoicePosition, contextBoat?: Boat): void {
    const boat = resolveInvoicePositionBoat(position, contextBoat);
    if (boat?.id) {
        position.boat = boat;
    }
}
